import * as React from 'react'
import * as Weebly from '../service/weebly'
import * as Event from '../service/event'
import {
  INameState
} from '../types'


export default class NameModal extends React.PureComponent<{
  name: string
  state: INameState
  isSaved: boolean
  onClose: () => void
  onSave: (name: string) => void
}> {

  componentDidMount() {
    Event.track('viewed_name', { name: this.props.name })
  }

  onBuy = () => {
    const { name } = this.props
    const url = Weebly.affiliateLink(name)
    window.open(url, '_blank')
    Event.track('bought_name', { name })
  }

  onSave = () => {
    const {
      onSave,
      name
    } = this.props
    onSave(name)
  }

  renderContent() {
    const {
      name,
      isSaved,
      state
    } = this.props

    if (state == 'taken') {
      return (
        <div>
          <p style={{textAlign: 'left'}}>Sorry, {name}.com is <strong>not</strong> available for purchase. Someone owns it, but they are not using it.</p>

          <p style={{textAlign: 'left'}}>You are seeing this suggestion because our initial check of domain availability only detects domains that <em>are in use</em>. We can do that extremely quickly and display results to you instantly. However, occasionally people buy domains and never do anything with them (there are no name servers). In that case, our initial check is wrong. So, we do a second, more thorough, check on all names that we suggest to you. That second check takes more time, and so we show you the original suggestion first and then cross it off if our second check shows it isn't available. That way you see suggestions instantly, and always know that our suggestions have available .com addresses.</p>
        </div>
      )
    } else {
      return (
        <div>
          <p style={{textAlign: 'left'}}>{name}.com is available. If you buy it using the link below, then I will get a small percentage which will help cover my hosting costs (thanks!).</p>

          <div className="modal-actions">

            <button
              onClick={this.onSave}
              className={isSaved ? 'modal-action-saved' : ''}
            >
              {isSaved ? 'Saved' : 'Save for later'}
            </button>
            <button
              className="modal-action-buy"
              onClick={this.onBuy}
            >
              Buy {name}.com
            </button>
          </div>
        </div>
      )
    }


  }

  render() {
    const {
      name,
      onClose,
    } = this.props

    return (
      <div className="modal name-modal">
        <div className="modal-content">

          <h1>{name}</h1>

          {this.renderContent()}

          <button
            className="modal-close"
            onClick={onClose}
          >
            &times;
          </button>

        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/name-modal.tsx